import { asyncAction } from '../../utils/actions';

export const fetchWidgetsList = asyncAction('widgets/FETCH_WIDGETS_LIST');
export const fetchWidgetDetails = asyncAction('widgets/FETCH_WIDGET_DETAILS');
export const saveWidgetPlacement = asyncAction('widgets/SAVE_WIDGET_PLACEMENT');
export const fetchDeviceReading = asyncAction('widgets/FETCH_DEVICE_READING');
